export default __webpack_public_path__ + "static/assign-agent-dark-e251ba27d94d9970caa1090f0d03b45f.png";